import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  Cell,
} from "recharts";

export default function DashboardCharts() {
  const eventData = [
    { name: "Jan", value: 120 },
    { name: "Feb", value: 140 },
    { name: "Mar", value: 150 },
  ];

  const volunteerData = [
    { name: "Q1", value: 100 },
    { name: "Q2", value: 350 },
    { name: "Q3", value: 140 },
    { name: "Q4", value: 240 },
    { name: "Q5", value: 120 },
    { name: "Q6", value: 440 },
  ];

  const collaborationData = [
    { name: "Type A", value: 80 },
    { name: "Type B", value: 30 },
    { name: "Type C", value: 90 },
  ];

  return (
    <div className="flex flex-col lg:flex-row lg:justify-between mt-5">
      {/* Event Volume */}
      <div className="border border-blue-200 rounded-xl p-4 shadow-sm w-full lg:w-[32%]">
        <h2 className="text-base font-popinsMedium text-[#121417]">
          Event Volume Over Time
        </h2>
        <h3 className="text-3xl font-popinsBold mt-2">150</h3>
        <p className="text-sm font-popinsRegular my-2 text-gray-500">
          Last 3 Months{" "}
          <span className="text-[#088738] font-popinsMedium">+10%</span>
        </p>
        <div className="mt-3 h-32">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={eventData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" />
              <YAxis hide />
              <Tooltip />

              <Bar dataKey="value" barSize={30} radius={[5, 5, 0, 0]}>
                {eventData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={
                      index === 0
                        ? "#3FC4E3" // Light Blue
                        : index === 1
                        ? "#0084A3" // Dark Cyan
                        : "#006881" // Teal Blue
                    }
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Volunteer Engagement */}
      <div className="border border-blue-200 rounded-xl p-4 shadow-sm w-full lg:w-[32%]">
        <h2 className="text-base font-popinsMedium text-[#121417]">
          Volunteer Engagement Trends
        </h2>
        <h3 className="text-3xl font-popinsBold mt-2">200</h3>
        <p className="text-sm font-popinsRegular my-2 text-gray-500">
          Last 6 Months{" "}
          <span className="text-[#088738] font-popinsMedium">+15%</span>
        </p>
        <div className="mt-3 h-32">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={volunteerData}>
              <XAxis dataKey="name" />
              <YAxis hide />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="value"
                stroke="#006881"
                strokeWidth={3}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Collaboration Breakdown */}
      <div className="border border-blue-200 rounded-xl p-4 shadow-sm w-full lg:w-[32%]">
        <h2 className="text-base font-popinsMedium text-[#121417]">
          Collaboration Breakdown by Type
        </h2>
        <h3 className="text-3xl font-popinsBold my-2">50</h3>
        <p className="text-sm font-popinsRegular text-gray-500">
          Current Quarter{" "}
          <span className="text-red-500 font-popinsMedium">-5%</span>
        </p>
        <div className="mt-3 h-32">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={collaborationData} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" horizontal={false} />
              <XAxis type="number" hide />
              <YAxis dataKey="name" type="category" />
              <Tooltip />

              <Bar dataKey="value" barSize={28} radius={[0, 5, 5, 0]}>
                {collaborationData.map((entry, index) => {
                  const colors = ["#006881", "#0084A3", "#3FC4E3"];
                  return (
                    <Cell
                      key={`cell-${index}`}
                      fill={colors[index % colors.length]}
                    />
                  );
                })}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
